import { CustomRadio } from '../../lib/CustomRadio';
import en from '../../lang/en-us';
import { ALL_HOLDINGS, NON_ZERO_HOLDINGS, ZERO_HOLDINGS } from '../../utils/constants';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
const { common } = en;

export default function HoldingTypeRadio(props: any) {
    return (
        <div className="holding-type-radio">
            <div className="desktop_mode">
                <CustomRadio
                    title={
                        <>
                            <img src="/images/filters.svg" alt="icon" />
                            {common.HoldingType.title}
                        </>
                    }
                    name="holding-type"
                    list={[
                        {
                            label: common.HoldingType.allHoldings,
                            value: ALL_HOLDINGS,
                        },
                        {
                            label: common.HoldingType.zeroHoldings,
                            value: ZERO_HOLDINGS,
                        },
                        {
                            label: common.HoldingType.nonZeroHoldings,
                            value: NON_ZERO_HOLDINGS,
                        },
                    ]}
                    {...props}
                />
            </div>
            <div className="mobile_mode">
                <FormControl variant="filled">
                    <InputLabel id="holding-type-mobile">{common.HoldingType.title}</InputLabel>
                    <Select
                        labelId="holding-type-mobile"
                        id="holding-type-dropdown"
                        value={props.selectedValue}
                        onChange={(e: any) => props.handleRadioChange(e.target.value)}
                    >
                        <MenuItem value={ALL_HOLDINGS}>{common.HoldingType.allHoldings}</MenuItem>
                        <MenuItem value={ZERO_HOLDINGS}>{common.HoldingType.zeroHoldings}</MenuItem>
                        <MenuItem value={NON_ZERO_HOLDINGS}>
                            {common.HoldingType.nonZeroHoldings}
                        </MenuItem>
                    </Select>
                </FormControl>
            </div>
        </div>
    );
}
